export default __webpack_public_path__ + "static/media/chat.09ee3d2a.png";